import { createSelector } from 'reselect';

// Config
import routeConstants from '../../constants/routeConstants';
import { getRouterLocationPathname } from '../../redux/reducers/router/routerSelector';

const ageVerificationCallbackState = createSelector([getRouterLocationPathname], (pathname) => ({
  isCancelledRoute: pathname.includes(routeConstants.CALLBACK_AGE_VERIFICATION_CANCEL),
}));

export default ageVerificationCallbackState;
